import { NextPage } from 'next'
import { makeLocaleStaticProps } from 'web_core/utils/static_props'
import { DefaultLayout } from '~/components/Layout/Default'

export const getStaticProps = makeLocaleStaticProps

const STRIPE_LINKS = [
  {
    label: '任意の金額（1回限り）',
    href: 'https://buy.stripe.com/4gM6oJ2XbfwGd9E5SKdIA00',
  },
  {
    label: '毎月応援（月額500円）',
    href: 'https://buy.stripe.com/00wcN7fJX5W65Hca90dIA01',
  },
  {
    label: '毎月応援（月額1,000円）',
    href: 'https://buy.stripe.com/8x200l8hv98i1qW94WdIA02',
  },
  {
    label: '毎月応援（月額3,000円）',
    href: 'https://buy.stripe.com/9B68wRcxL84e3z4dlcdIA03',
  },
  {
    label: '毎月応援（月額10,000円）',
    href: 'https://buy.stripe.com/aFa3cxeFTfwG1qWgxodIA04',
  },
]

const STRIPE_BILLING_PORTAL_LINK =
  'https://billing.stripe.com/p/login/4gM6oJ2XbfwGd9E5SKdIA00'

const PAYPAL_LINKS = [
  {
    label: '任意の金額（1回限り）',
    href: 'https://paypal.me/mathpedia',
  },
  {
    label: '毎月応援（月額500円）',
    href: 'https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-0JX2310431993211GNKOXUYY',
  },
  {
    label: '毎月応援（月額1,000円）',
    href: 'https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-1CA60197AN9882646MBNNZEQ',
  },
  {
    label: '毎月応援（月額3,000円）',
    href: 'https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-9FU58741NJ1739248MBNOSTA',
  },
  {
    label: '毎月応援（月額10,000円）',
    href: 'https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-52N52818U6300643LMBNOXDQ',
  },
]

const Page: NextPage = () => {
  return (
    <DefaultLayout
      head={{
        title: 'Mathpediaの活動を支援',
        description:
          'Mathpediaの運営は皆様からのご支援によって成り立っております。StripeまたはPayPalによる寄付（1回限り・毎月）、採用をお考えの企業様向けの広告掲載、Amazonアソシエイト・プログラムによる支援をご用意しております。',
      }}
      categoriesMenu={{ pc: true, sp: true, spFixed: true }}
      leftSidebar
      rightSideBar
    >
      <div className="mathdown-monotone">
        <h1>Mathpediaの活動を支援</h1>

        <p>
          Mathpediaの運営は、皆様からのご支援によって成り立っております。現在、次の3つの方法をご用意しております。
        </p>

        <h2>1. 寄付</h2>

        <p>
          1度きりのご支援と、毎月の定額でのご支援をお選びいただけます。決済はStripeまたはPayPalで承ります。なお、こちらの寄付に関しては、現時点では返礼品などの特典は用意しておりません。
        </p>

        <p>
          いただいたご支援は、記事の執筆・監修をしてくださる方々への対価と、サイトの運営費に充てられます。
        </p>

        <h3>Stripeでのご支援</h3>

        <ul>
          {STRIPE_LINKS.map(({ label, href }) => (
            <li key={href}>
              <a rel="nofollow" href={href}>
                {label}
              </a>
            </li>
          ))}
        </ul>

        <p>
          毎月のご支援は、いつでもご自身で解約いただけます。
          <a rel="nofollow" href={STRIPE_BILLING_PORTAL_LINK}>
            解約・お支払い方法の変更はこちら
          </a>
          。
        </p>

        <h3>PayPalでのご支援</h3>

        <ul>
          {PAYPAL_LINKS.map(({ label, href }) => (
            <li key={href}>
              <a rel="nofollow" href={href}>
                {label}
              </a>
            </li>
          ))}
        </ul>

        <p>
          毎月のご支援は、いつでもご自身で解約いただけます。PayPalにログインし、「アカウント設定」→「支払い」→「自動支払い」からお手続きください。
        </p>

        <h2>2. 広告掲載（採用をお考えの企業の皆様へ）</h2>

        <p>
          Mathpediaには、大学レベル以上の数学を自ら学ぶ学生・社会人の方々が日常的に訪れています。
          <strong>
            純粋数学の素養を持つ人材の採用をお考えの企業様に向けて、サイト右枠に広告枠をご用意しております。
          </strong>
        </p>

        <p>
          抽象的な理論を粘り強く追う訓練を積んだ方々に、直接リーチしていただける場です。掲載条件・料金・枠の空き状況につきましては、下記までお問い合わせください。
        </p>

        <p>
          <strong>
            お問い合わせ： <a href="mailto:admin@math.jp">admin@math.jp</a>
          </strong>
        </p>

        <p>
          なお、掲載いただく広告は、記事の内容・参考文献の選定・記述の方針に一切影響しません。
        </p>

        <h2>3. Amazonアソシエイト・プログラム</h2>

        <p>
          Mathpediaは、Amazon.co.jpを宣伝しリンクすることによってサイトが紹介料を獲得できる手段を提供することを目的に設定されたアフィリエイトプログラムである、Amazonアソシエイト・プログラムの参加者です。
        </p>

        <p>
          記事の参考文献に掲載している書籍のリンクには、アソシエイトIDを含むものがあります。これらのリンクを経由して商品をご購入いただいた場合、Mathpediaに紹介料が支払われることがあります。紹介料はサイトの運営費に充てられます。
        </p>

        <p>
          <strong>
            紹介料の有無は、参考文献として挙げる書籍の選定に一切影響しません。
          </strong>
          参考文献は、記事の内容に必要なものだけを学術的な観点から選んでおります。読者の皆様が書籍をご購入になる際、当サイトのリンクをお使いいただければ、それだけで運営のご支援になります。
        </p>

        <h2>お問い合わせ</h2>

        <p>
          記事の誤りのご指摘、ご支援に関するお問い合わせ、その他のご連絡は{' '}
          <a href="mailto:admin@math.jp">admin@math.jp</a>{' '}
          までお願いいたします。
        </p>

        <h2>運営者情報</h2>

        <p>運営者： 合同会社舞子天野ビル</p>
        <p>
          お問い合わせ： <a href="mailto:admin@math.jp">admin@math.jp</a>
        </p>
      </div>
    </DefaultLayout>
  )
}

export default Page
